import React, { useState, useRef, useEffect } from 'react';

interface ClassicScreenShellProps {
  title: string;
  tenantName?: string;
  selectedYear?: number;
  onYearChange?: (year: number) => void;
  onBack?: () => void;
  rightContent?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Windows 95風のヘッダー + 背景を備えた共通ラッパー。
 * 各クラシック画面で使い回し、メインメニューとの往復を簡単にする。
 */
const ClassicScreenShell: React.FC<any> = ({
  title,
  onBack,
  rightContent,
  tenantName,
  selectedYear,
  onYearChange,
  children,
}) => {
  const [yearChangeNotice, setYearChangeNotice] = useState<string | null>(null);
  const noticeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (noticeTimeoutRef.current) clearTimeout(noticeTimeoutRef.current);
    };
  }, []);

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = parseInt(e.target.value, 10);
    if (onYearChange && newYear !== selectedYear) {
      onYearChange(newYear);
      setYearChangeNotice(
        `${newYear}年度に切り替えました。伝票の日付は${newYear}年4月1日〜${newYear + 1}年3月31日の範囲で入力してください。`
      );
      if (noticeTimeoutRef.current) clearTimeout(noticeTimeoutRef.current);
      noticeTimeoutRef.current = setTimeout(() => {
        setYearChangeNotice(null);
        noticeTimeoutRef.current = null;
      }, 6000);
    }
  };

  // Generate a list of years, e.g., current year +/- 5 years
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  return (
    <div
      style={{
        backgroundColor: '#f0f0f0',
        minHeight: '100vh',
        fontFamily: "'MS UI Gothic', 'Hiragino Kaku Gothic ProN', sans-serif",
        fontSize: '11px',
        color: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: '#0066cc',
          color: '#ffffff',
          padding: '8px 16px',
          borderBottom: '2px solid #004499',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{title}</div>
            {tenantName && (
              <div style={{ fontSize: '16px', color: '#ffffff', marginTop: '4px', fontWeight: 'bold' }}>
                <span style={{ fontSize: '12px', fontWeight: 'normal', opacity: 0.9 }}>利用中の保育園：</span>
                {tenantName}
              </div>
            )}
          </div>

          {selectedYear !== undefined && onYearChange && (
            <div style={{ marginLeft: '24px', display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.2)', padding: '4px 8px', borderRadius: '4px' }}>
              <span style={{ marginRight: '8px', fontSize: '12px', fontWeight: 'bold' }}>対象年度:</span>
              <select
                value={selectedYear}
                onChange={handleYearChange}
                style={{
                  padding: '2px 6px',
                  borderRadius: '4px',
                  border: '1px solid rgba(255, 255, 255, 0.4)',
                  backgroundColor: '#ffffff',
                  color: '#000000',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                {yearOptions.map(year => (
                  <option key={year} value={year}>{year}年度</option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          {rightContent}
          {onBack && (
            <button
              type="button"
              title="現在の保育園のメインメニューに戻ります（保育園はそのまま）"
              onClick={onBack}
              style={{
                backgroundColor: '#e0e0e0',
                border: '2px outset #e0e0e0',
                padding: '4px 10px',
                fontSize: '11px',
                cursor: 'pointer',
                fontFamily: "'MS UI Gothic', sans-serif",
              }}
              onMouseDown={(e) => (e.currentTarget.style.border = '2px inset #e0e0e0')}
              onMouseUp={(e) => (e.currentTarget.style.border = '2px outset #e0e0e0')}
              onMouseLeave={(e) => (e.currentTarget.style.border = '2px outset #e0e0e0')}
            >
              メニューに戻る
            </button>
          )}
        </div>
      </div>
      {yearChangeNotice && (
        <div
          style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            color: '#856404',
            padding: '10px 16px',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {yearChangeNotice}
        </div>
      )}
      <div style={{ padding: '20px' }}>{children}</div>
    </div>
  );
};

export default ClassicScreenShell;

